module.exports = __webpack_public_path__ + "static/img/19.cce7c6d7.jpg";